import { render, staticRenderFns } from "./ListaDocumentos.vue?vue&type=template&id=6dc8afa5"
import script from "./ListaDocumentos.vue?vue&type=script&lang=js"
export * from "./ListaDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports